import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
var Rebase = require('re-base');
var firebase = require('firebase');
//document.title = "R & M";
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js